import { render, staticRenderFns } from "./CustomSolutionLoader.vue?vue&type=template&id=3c67c204&scoped=true"
import script from "./CustomSolutionLoader.vue?vue&type=script&lang=js"
export * from "./CustomSolutionLoader.vue?vue&type=script&lang=js"
import style0 from "./CustomSolutionLoader.vue?vue&type=style&index=0&id=3c67c204&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c67c204",
  null
  
)

export default component.exports